import { createSlice } from "@reduxjs/toolkit";
import { WebVisitState } from "./webVisit.state";
import { postWebVisit } from "./webVisit.thunk";

const initialState: WebVisitState = {
  logged: false,
  status: "idle",
};

export const webVisitSlice = createSlice({
  name: "webVisit",
  initialState,
  reducers: {},
  extraReducers: (build) => {
    build
      .addCase(postWebVisit.pending, (state) => {
        state.status = "loading";
      })
      .addCase(postWebVisit.fulfilled, (state) => {
        state.status = "success";
        state.logged = true;
      })
      .addCase(postWebVisit.rejected, (state) => {
        state.status = "error";
        state.logged = true;
      });
  },
});

export default webVisitSlice.reducer;
